/**
 * Geração do sumário do documento LaTeX
 * Lista as seções principais e subseções com numeração e números de página
 */

import { DadosApreciacao, Risco } from '../core/latex-types';

/**
 * Gera o sumário do documento LaTeX dinamicamente
 * O sumário é inserido após a capa e antes das seções iniciais
 * @param _dados Dados da apreciação
 * @param _riscos Lista de riscos para gerar as partes no sumário
 */
export function gerarSumarioLatex(_dados?: DadosApreciacao, _riscos?: Risco[]): string {
  // O sumário agora é gerado automaticamente pelo LaTeX usando \tableofcontents
  // As entradas são adicionadas via \addcontentsline em cada seção
  return `
\\newpage
\\thispagestyle{empty}

\\tableofcontents

\\newpage
\\pagestyle{fancy}
`;
}

